import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerSparkComponents } from 'genesys-spark';
import { registerCustomElements } from 'iframe-coordinator';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

registerSparkComponents().catch((e) => console.error("Spark components didn't load"));
registerCustomElements();
